import { RedocStandalone } from 'redoc';

export const PublicApiDocumentation = () => (
  <RedocStandalone specUrl="https://public-api.inventa.dev.br/v3/api-docs.yaml/public-api" />
);
